export default __webpack_public_path__ + "471f643dc1b45c3c54a40bd8aaafc2de.svg";